//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.DisplayPaint.js";
import "../CAM/CAM.DisplayPath.js";
import "../CAM/CAM.DisplaySilhouette.js";
import "../CAM/CAM.DisplayTool.js";
let d=[[[0,"ArrowDisplayFlag",1,0],[0,"DisplayCutRegionsFlag",1,0],[0,"FeedDisplayFlag",1,0],[0,"LineNumberDisplayFlag",1,0],[1,"PaintDisplay",0,"CAM.DisplayPaint",0],[1,"PathDisplay",0,"CAM.DisplayPath",0],[0,"PathDisplayColors",0,"CAM.PathDisplayColors",0],[0,"PathDisplayType",1,0],[0,"PathNormalType",1,0],[0,"PathVector",1,"Direction",0],[0,"PatternDisplayFrequency",1,0],[0,"PatternDisplayType",1,0],[0,"PatternFile",1,0],[0,"PatternXOffset",1,0],[0,"PatternYOffset",1,0],[0,"PatternZOffset",1,0],[0,"PauseAfterDisplayFlag",1,0],[0,"PercentOfTool",1,0],[0,"RefreshBeforeDisplayFlag",1,0],[0,"ReplaySpeed",1,0],[0,"SaveContactDisplayDataFlag",1,0],[1,"SilhouDisplay",0,"CAM.DisplaySilhouette",0],[0,"SuppressPathDisplayFlag",1,0],[1,"ToolDisplay",0,"CAM.DisplayTool",0],[0,"ToolDisplayFrequency",1,0],[0,"ToolDisplayType",1,0]],[],[]];
SPLM.CAM.OperationDisplayOptionsBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.OperationDisplayOptionsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.OperationDisplayOptionsBuilder.ToolDisplayTypes = Object.freeze({
    "None" : "None", "Tool2d" : "Tool2d", "Tool3d" : "Tool3d", "Axis" : "Axis"});

SPLM.CAM.OperationDisplayOptionsBuilder.PatternDisplayTypes = Object.freeze({
    "None" : "None", "Specify" : "Specify"});

SPLM.CAM.OperationDisplayOptionsBuilder.PathDisplayTypes = Object.freeze({
    "SolidCenter" : "SolidCenter", "DashedCenter" : "DashedCenter", "Silhouette" : "Silhouette", "Fill" : "Fill", "SilhouetteFill" : "SilhouetteFill"});

SPLM.CAM.OperationDisplayOptionsBuilder.PathNormalTypes = Object.freeze({
    "TypesToolAxis" : "TypesToolAxis", "TypesSpecify" : "TypesSpecify"});

export default SPLM;